import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import axios from "axios";
import Alert from "@mui/material/Alert";
import DialogTitle from "@mui/material/DialogTitle";
import AuthContext from "../context/userAuth.context";
import { fontWeight } from "@mui/system";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

export default function UpdateTags(props) {
  const [data, setData] = useState([]);
  const [itemName, setItemName] = useState("");
  const [tag, setTag] = useState("");
  const { authenticationData } = useContext(AuthContext);
  const [showAlert, setShowAlert] = useState("");

  useEffect(() => {
    GetTagsbyId();
  }, [props.itemId]);

  useEffect(() => {
    if (data.length > 0) {
      if (props.type === "Objects") {
        setItemName(data[0].name);
        setTag(data[0].tags);
      } else if (props.type === "Props") {
        setItemName(data[0].filename);
        setTag(data[0].tags);
      } else if (props.type === "Shapes") {
        setItemName(data[0].name);
        setTag(data[0].tags);
      } else if (props.type === "Templates") {
        setItemName(data[0].projectName);
        setTag(data[0].tags);
      }
    }
  }, [data]);

  const GetTagsbyId = () => {
    var formdata = new FormData();
    formdata.append("itemId", props.itemId);
    formdata.append("assetType", props.type);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Administration/getTagbyItemId",
        formdata
      )
      .then((response) => {
        console.log('response.data', response.data)
        setData([...response.data.response]);
      });
  };

  const UpdateTags = () => {
    let formdata = new FormData();
    formdata.append("itemId", props.itemId);
    formdata.append("tag", tag);
    formdata.append("itemname", itemName);
    formdata.append("assetType", props.type);

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Administration/UpdateTagbyItemId",
        formdata
      )
      .then((response) => {
        if (response.data.response === "Success") {
          setShowAlert("success");
          GetTagsbyId();
        } else {
          setShowAlert("error");
        }
      });
  };
  const handleClose = () => {
    props.setOpen(false);
  };

  const generatetag = () => {
    let formdata = new FormData();
    formdata.append("itemId", props.itemId);
    formdata.append("itemname", itemName);
    formdata.append("assetType", props.type);

    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Administration/generateTagbyItem",
        formdata
      )
      .then((res) => {
        var data = res.data.response;
        if (data != undefined) {
          setTag(data.tags);
        }
      });
  };

  return (
    <div>
      <>
        <Dialog open={props.open} >
          <DialogTitle
            style={{ color: "black", fontWeight: "bold", textAlign: "center" }}
          >
            Assign Tags
            <Button
              size="small"
              color="error"
              onClick={handleClose}
              style={{ float: "right", marginRight: 5 }}
            >
              <CloseIcon />
            </Button>
          </DialogTitle>
          <DialogContent>
            {showAlert == "error" && (
              <Alert severity="error">Failed.Please contact Support</Alert>
            )}

            {showAlert == "success" && (
              <Alert severity="success">Success</Alert>
            )}
            {data.length > 0 && (
              <>
                <TextField
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                  id="standard-basic"
                  label="Item Name"
                  variant="standard"
                />
                <br />
                <br />
                <textarea
                  hideBackdrop={{ invisible: true }}
                  id="name"
                  label="Tags"
                  type="text"
                  style={{ height: 500, zIndex: -1, width: 500 }}
                  value={tag}
                  onChange={(e) => setTag(e.target.value)}
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            {props.type != "Templates" && 
            <Button variant="contained" onClick={generatetag}>
              Generate Tag
            </Button>
            }
            <Button variant="contained" onClick={UpdateTags}>
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  );
}
